export enum ReportModal {
  TABLE_PDF = 'table-pdf',
  TABLE_CSV = 'table-csv',
  REPORTS_PDF = 'reports-pdf',
  REPORTS_CSV = 'reports-csv',
  DATA_TRANSFER = 'data-transfer',
}

export type ReportTypes = `${ReportModal}`;
